import { useContext, useRef, useEffect } from 'react';
import ModalContext from '../../Store/ModalContext';
import LanguageContext from '../../Store/LanguageContext';
import { translate } from '../../Components/translate/translate';
import CreateAssessmentPopup from '../CreateAssessmentPopUp/CreateAssessmentPopup';
import EmailResultsModal from '../EmailResultsModal/EmailResultsModal';
import './GenericModal.scss';

const GenericModal = () => {
  const modalCtx = useContext(ModalContext);
  const langCtx = useContext(LanguageContext);
  const modalRef = useRef();

  // Disable background scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = modalCtx.open ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [modalCtx.open]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      modalCtx.closeModal();
    }
  };

  const handleTranslate = (text, type) => {
    switch (langCtx.language) {
      case "Nederlands": {
        return translate(text, "genericModalDutch", type);
      }
      default: {
        return text;
      }
    }
  };


  if (!modalCtx.open) return null;

  const renderModalContent = () => {
    switch (modalCtx.modal) {
      case 'createAssessment':
        return <CreateAssessmentPopup handleTranslate={handleTranslate} />;
      
      case 'emailResults':
        return <EmailResultsModal 
          isModalOpen={modalCtx.open} 
          onClose={modalCtx.closeModal} 
          hashId={modalCtx.modalData.hashId} 
        />;
      
      default:
        return null;
    }
  };

  // For email modal, render it directly without the generic modal wrapper
  if (modalCtx.modal === 'emailResults') {
    return renderModalContent();
  }

  return (
    <div className="overlay" onClick={handleOverlayClick}>
      <div className="modal" ref={modalRef}>
        {renderModalContent()}
      </div>
    </div>
  );
};

export default GenericModal;
